import { render, staticRenderFns } from "./LotRecallDialog.vue?vue&type=template&id=90f5cad8&"
import script from "./LotRecallDialog.vue?vue&type=script&lang=js&"
export * from "./LotRecallDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports